<template>
  <div>
    <div class="scroll card-layout mt-2">
      <p class="source-sans-pro terms-heading">{{$t('REGISTRATION_PAGE.TERMS_AND_CONDITIONS')}}</p>
      <div class="row m-0 p-0">
        <div class="col m-0" v-if="terms.length==1">
          <div class="terms lato-regular m-0 p-0 ml-5 pr-3" v-html="terms[0]"></div>
        </div>    
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["terms"],
  // components: {},
  data() {
    return {
      allTerms: null
    };
  },
  computed: {
    // Allterms: function() {
    //   console.log(this.terms);
    //   return this.terms;
    // }
  },
  watch: {
    terms: function(newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.allTerms = newVal;
      return this.allTerms;
    }
  }
  // methods: {
  //   checkTerms(event) {
  //     this.accepted = event;
  //   },
  //   goBack() {
  //     this.$emit("goBack", event);
  //   },
  //   goToUserDetails() {
  //     if (this.accepted) {
  //       this.$emit("termsAndConditionsAccepted", this.accepted);
  //     }
  //   }
  // }
};
</script>

<style>
.terms-heading {
  padding-left: 50px;
  padding-top: 50px;
  font-size: 30px;
  font-weight: normal;
  text-align: left;
  color: #0071bc;
}
.terms {
  padding: 50px;
  height: 50vh;
  overflow: auto;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.2px;
  text-align: left;
  color: #002d72;
  text-align: justify;
}
.terms-conditions {
  margin-bottom: 50px;
  height: auto;
  margin: 0 auto;
  display: block;
  background: #edf2fa;
  width: fit-content;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.23;
  letter-spacing: normal;
  color: #0071bc;
  padding: 10px;
}

/* width */
.scroll > ::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.scroll > ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #d8d8d8;
  border-radius: 10px;
}

/* Handle */
.scroll > ::-webkit-scrollbar-thumb {
  background: #0071bc;
  border-radius: 10px;
}

/* Handle on hover */
.scroll > ::-webkit-scrollbar-thumb:hover {
  background: #0071bc90;
}
</style>